import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { DataService } from "../_services/data.service";

@Component({
  moduleId: module.id,
  templateUrl: "notok.component.html",
})
export class PaymentNotOkComponent implements OnInit {
  model: any = {};
  loading = false;
  errorCode: string;
  errorMessage: string;
  messages: any;

  constructor(
    private router: Router,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute
  ) {
    this.messages = JSON.parse(localStorage.getItem("messages"));
  }

  ngOnInit() {
    this.dataService.getUsersData(null).subscribe((data) => {});
    let params = this.activatedRoute.snapshot.queryParams;
    let resp = "";
    if (params && params.ErrorCode) {
      this.errorCode = params.ErrorCode;
    }
    if (params && params.ErrorText) {
      this.errorMessage = params.ErrorText;
    }

    if (params) {
      this.dataService.sendPaymentError(params).subscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/notok.component.ts